import { render, staticRenderFns } from "./ReviewStateNotification.vue?vue&type=template&id=23ba4ef5&scoped=true&lang=html&"
import script from "./ReviewStateNotification.vue?vue&type=script&lang=coffee&"
export * from "./ReviewStateNotification.vue?vue&type=script&lang=coffee&"
import style0 from "./ReviewStateNotification.vue?vue&type=style&index=0&id=23ba4ef5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ba4ef5",
  null
  
)

component.options.__file = "ReviewStateNotification.vue"
export default component.exports